import { memo, useRef } from 'react';
import LoadingSpinner from '../../../components/loadingSpinner/LoadingSpinner';


export default memo(function DynamicField(props: {
  title: string,
  field_label?: string,
  hide_add_field?: boolean,
  original_entries: string[],
  active_entries: string[],
  removeEntry: (entry: string) => void,
  addEntry: (entry: string) => void,
  removeAll: () => void,
}) {
  const inputRef = useRef<HTMLInputElement>(null);

  // Both the Enter key and the + button add whatever is currently in the input.
  // Reading the ref into a local narrows the value to a string for addEntry.
  const addFromInput = () => {
    const input = inputRef.current;
    if (input && input.value !== "") {
      props.addEntry(input.value);
      input.value = "";
    }
  };

  return (<div className='p-2 fs-8 mb-4 efas-heading-border-bottom'>
    <div>{props.title}</div>
    {!props.original_entries ?
      <LoadingSpinner className='mx-auto text-center p-0 m-0' /> :
      <>
        <div className="d-flex flex-row me-auto user-select-none">
          <div className="d-flex flex-row flex-wrap me-auto">
            {props.active_entries.map((entry, _) => (
              <div className="border rounded mx-1 compose-item my-auto">
                <span role="button" className="border-end px-2 py-1 compose-item-remove" onClick={() => props.removeEntry(entry)}>×</span>
                <span className="px-1">{entry}</span>
              </div>
            ))}
          </div>
          <div className="my-auto">
            <button className="p-2 py-1 mx-1 btn btn-outline-danger" type="button" id={`${props.title}-remove-all-button`}
              onClick={() => props.removeAll()}>×</button>
          </div>
          {props.original_entries.length === 0 ? null :
            <div className="dropdown my-auto">
              <button className="p-3 py-1 btn btn-warning dropdown-toggle" type="button" id={`${props.title}-dropdown-button`} data-bs-toggle="dropdown" aria-expanded="false">
              </button>
              <ul className=" dropdown-menu overflow-auto" aria-labelledby={`${props.title}-dropdown-button`} style={{ maxHeight: "60vh" }}>
                {props.original_entries.map((entry, index) => (
                  <li key={index}>
                    <span role="button" className={`dropdown-item ${props.active_entries.includes(entry) ? "fw-bold" : ""}`}
                      onClick={() => props.active_entries.includes(entry) ? props.removeEntry(entry) : props.addEntry(entry)}>{entry}</span>
                  </li>
                ))}
              </ul>
            </div>
          }
        </div>

      </>
    }
    {props.hide_add_field ? null :
      <div className='input-group input-group-sm my-1' style={{ width: "fit-content" }}>
        <input ref={inputRef} type='email' className="form-control form-control-sm mx-1" id={`${props.title}-input`} placeholder={`Add ${props.field_label || "email"} ...`} required={true} aria-label="Add email ..." aria-describedby={`${props.title}-add-button`}
          onKeyDown={(ev) => {
            if (ev.key === 'Enter') {
              ev.preventDefault();
              addFromInput();
            }
          }} />
        <div role='button' className="btn btn-outline-primary" id={`${props.title}-add-button`} onClick={addFromInput}>+</div>
      </div>
    }
  </div>);
});